<template>
  <Dialog v-model="showCode" :showConfirmButton="false">
    <div class="mini-code-index">
      <img
        src="@/assets/close.png"
        alt
        class="close_img"
        @click="closeCodeModal"
      />
      <img :src="miniCodeImageUrl" class="imgCode" />
      <p>保存图片 微信识别小程序码进入</p>
    </div>
  </Dialog>
</template>
<script>
import { Dialog } from "vant";
export default {
  data() {
    return {
      showCode: false,
      miniCodeImageUrl: "",
    };
  },
  methods: {
    closeCodeModal() {
      this.showCode = !this.showCode;
    },
    openApplets({ pageCode, pageQueryParam, isShow }) {
      let appversion = window.tools.getversion(); //更具版本判断是否在APP
      const isInWechatMP = () => {
        // 在判断是否是在小程序
        return (
          (navigator.userAgent.match(/micromessenger/i) &&
            navigator.userAgent.match(/miniprogram/i)) ||
          window.__wxjs_environment === "miniprogram"
        );
      };
      if (appversion || isInWechatMP()) {
      } else {
        if (isShow) {
          this.$dialog.alert({
            message: isShow,
            confirmButtonColor: "#F8A651",
          });
          return;
        }
        this.http({
          url: "/order/shortLink/miniCode",
          method: "post",
          parmes: {
            pageCode: pageCode,
            pageQueryParam: pageQueryParam,
          },
        }).then((rps) => {
          if (rps.code == 200) {
            this.miniCodeImageUrl = rps.data.miniCodeImageUrl;
            this.closeCodeModal();
          }
        });
      }
    },
  },
  components: { Dialog: Dialog.Component },
};
</script>
<style lang="less" scoped>
.mini-code-index {
  text-align: center;
  position: relative;
  .imgCode {
    width: 300px;
    height: 300px;
    padding: 100px 80px 0px 80px;
    object-fit: cover;
  }
  .close_img {
    width: 60px;
    height: 60px;
    object-fit: cover;
    position: absolute;
    top: 20px;
    right: 20px;
  }
  p {
    font-size: 28px;
    color: #333;
    font-weight: bold;
    padding-top: 50px;
    padding-bottom: 70px;
  }
}
</style>